import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enResearch from './locales/en/research.json';
import enPlanner from './locales/en/planner.json';
import enConsulting from './locales/en/consulting.json';
import koCommon from './locales/ko/common.json';
import koAuth from './locales/ko/auth.json';
import koResearch from './locales/ko/research.json';
import koPlanner from './locales/ko/planner.json';
import koConsulting from './locales/ko/consulting.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        research: enResearch,
        planner: enPlanner,
        consulting: enConsulting,
      },
      ko: {
        common: koCommon,
        auth: koAuth,
        research: koResearch,
        planner: koPlanner,
        consulting: koConsulting,
      },
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
